import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ws-shift-summary',
  templateUrl: './shift-summary.component.html',
  styleUrls: ['./shift-summary.component.scss']
})
export class ShiftSummaryComponent {

  @Input() totalStops: number = 0;
  @Input() totalAmount: number = 0;
  @Input() totalAmountCompleted: number = 0;
  @Input() totalDistance: number = 0;
  @Input() distanceOut: number = 0;
  @Input() distanceBetween: number = 0;
  @Input() distanceHome: number = 0;
  
  @Input() totalDuration: number = 0;
  @Input() currency: string = 'DKK';

  showDetails = false;

  onMouseOut() {
    this.showDetails = false;
  }

  onMouseOver() {
    this.showDetails = true;
  }
}
